import { Button } from '@athena/forge';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { onLogout } from '../../utils/widget-facade';
import { getLocalizedString } from '../../utils/i18n-utils';


export default function LogoutLink({ oktaButton }: { oktaButton?: JQuery }) {
  const buttonText = getLocalizedString('error.athena.click.to.logout');
  return (
    <Button
      text={buttonText}
      onClick={async () => {
        AmplitudeUtils.logCustomEvent('TerminalView::LogoutButtonClick', {});
        await onLogout();
        oktaButton?.trigger('click');
      }}
      variant="tertiary"
      size="small"
    />
  );
}
